import { useContext } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";

import { AuthContext } from "../../context/AuthProvider";
import { AppContext } from "../../context/AppProvider";
import { fetchWithInterceptor } from "../../utils/fetchWithInterceptor";

export default function ConfirmPDFCreationDialog({
  open,
  onClose,
  pendingPdfId,
  isLoading,
  setIsLoading,
  refresh,
}) {
  const authContext = useContext(AuthContext);
  const appContext = useContext(AppContext);

  const handleGeneratePdf = async (pdfId) => {
    try {
      setIsLoading(true);

      const response = await fetchWithInterceptor("/api/product-labels/generate-price-tags", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-access-token": authContext.getToken(),
        },
        body: JSON.stringify({ fileLogId: pdfId }),
      });

      if (response.ok) {
        const data = await response.json();
        window.open(data.url, '_blank');

        refresh(); // Recargar la lista
      } else {
        const errorData = await response.json();
        appContext.showMessage(
          errorData.error || "Error generating PDF",
          "error"
        );
      }
    } catch (err) {
      console.error("Error generating PDF:", err);
      appContext.showMessage("Error generating PDF", "error");
    } finally {
      setIsLoading(false);
    }
  };

  const handleConfirm = async () => {
    if (!pendingPdfId) return;
    await handleGeneratePdf(pendingPdfId);
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Confirm</DialogTitle>
      <DialogContent>
        <Typography>
          Are you sure you want to finish scanning and generate the labels for
          printing?
        </Typography>
        <Typography>
          This will finalise your selection and prepare the labels as a
          printable PDF.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={isLoading}>Go Back</Button>
        <Button variant="contained" color="primary" onClick={handleConfirm} loading={isLoading}>
          Generate Labels
        </Button>
      </DialogActions>
    </Dialog>
  );
}
